import { render } from "./StockManagement.vue?vue&type=template&id=671e5202&scoped=true"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"

import "./StockManagement.vue?vue&type=style&index=0&id=671e5202&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671e5202"]])

export default __exports__